module.exports = __webpack_public_path__ + "static/media/marxeed_logo_tag.b7a47a4d.png";